import React from "react";

export default function NotificationBanner({ notifications }) {
  if (!notifications) {
    return null;
  }

  const hasNoUrgentActions =
    notifications.overdueFollowUps.length === 0 &&
    notifications.dueTodayFollowUps.length === 0 &&
    notifications.hotUncontactedLeads.length === 0;

  return (
    <div style={notificationGridStyle}>
      {notifications.overdueFollowUps.length > 0 && (
        <a href="/admin/follow-ups" style={notificationCardDanger}>
          🔴 {notifications.overdueFollowUps.length} overdue follow-up
          {notifications.overdueFollowUps.length === 1 ? "" : "s"}
        </a>
      )}

      {notifications.dueTodayFollowUps.length > 0 && (
        <a href="/admin/follow-ups" style={notificationCardWarning}>
          🟡 {notifications.dueTodayFollowUps.length} follow-up
          {notifications.dueTodayFollowUps.length === 1 ? "" : "s"} due today
        </a>
      )}

      {notifications.hotUncontactedLeads.length > 0 && (
        <div style={notificationCardHot}>
          🔥 {notifications.hotUncontactedLeads.length} hot lead
          {notifications.hotUncontactedLeads.length === 1 ? "" : "s"} need attention
        </div>
      )}

      {hasNoUrgentActions && (
        <div style={notificationCardGood}>
          ✅ No urgent CRM actions today
        </div>
      )}
    </div>
  );
}

const notificationGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 12,
  marginTop: 20,
  marginBottom: 24
};

const notificationCardBase = {
  padding: "14px 16px",
  borderRadius: "12px",
  fontWeight: 700,
  textDecoration: "none",
  display: "block"
};

const notificationCardDanger = {
  ...notificationCardBase,
  background: "#fee2e2",
  color: "#991b1b",
  border: "1px solid #fecaca"
};

const notificationCardWarning = {
  ...notificationCardBase,
  background: "#fef3c7",
  color: "#92400e",
  border: "1px solid #fde68a"
};

const notificationCardHot = {
  ...notificationCardBase,
  background: "#fff1f2",
  color: "#9f1239",
  border: "1px solid #fecdd3"
};

const notificationCardGood = {
  ...notificationCardBase,
  background: "#dcfce7",
  color: "#166534",
  border: "1px solid #bbf7d0"
};